import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { useAppDispatch } from "hooks/useAppStore";
import { setCredentials } from "store/slices/authSlice";
import { login } from "api";
import { Spinner } from "components/common";

export default function LoginPage() {
  const dispatch  = useAppDispatch();
  const navigate  = useNavigate();
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const { mutate, isPending, error } = useMutation({
    mutationFn: login,
    onSuccess: (data) => {
      dispatch(setCredentials(data));
      navigate("/");
    },
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    mutate({ email, password });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="card w-full max-w-sm p-8">
        {/* Logo */}
        <div className="text-center mb-8">
          <h1 className="text-2xl font-semibold text-brand-600">Bridge 13</h1>
          <p className="text-sm text-gray-400 mt-1">Food rescue logistics</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="label">Email</label>
            <input
              type="email"
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
              autoFocus
            />
          </div>

          <div>
            <label className="label">Password</label>
            <input
              type="password"
              className="input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>

          {error && (
            <p className="text-sm text-red-500">Invalid email or password.</p>
          )}

          <button type="submit" className="btn-primary w-full" disabled={isPending}>
            {isPending ? <Spinner className="h-4" /> : "Sign in"}
          </button>
        </form>

        <button
          onClick={() => navigate("/forgot-password")}
          className="mt-4 text-xs text-gray-400 hover:text-brand-600 w-full text-center transition-colors"
        >
          Forgot your password?
        </button>
      </div>
    </div>
  );
}
